import React from "react";
import { usePowerDialer } from "@/context/PowerDialerContext";
import { useGetCallDispositionsQuery } from "@/store/rest_api";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { dispositionShortcutKey } from "@/util/dispositions";

interface DispositionDockProps {
  onSaveAndNext: () => void;
  isSaving: boolean;
}

export function DispositionDock({ onSaveAndNext, isSaving }: DispositionDockProps) {
  const { activeCall, selectDisposition } = usePowerDialer();
  const { data: dispositions = [] } = useGetCallDispositionsQuery({});

  if (!activeCall) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center gap-2.5 border-t border-border pt-4">
      <span className="mr-1 text-sm font-bold uppercase tracking-wider text-muted-foreground">
        Disposition
      </span>
      {dispositions.map((disposition, index) => (
        <button
          key={disposition.id}
          className={cn(
            "flex items-center gap-2 rounded-full border border-border px-4 py-2 text-base font-semibold transition-colors hover:bg-muted/50",
            activeCall.disposition === disposition.name &&
              "border-primary bg-primary/10 text-primary hover:bg-primary/10",
          )}
          onClick={() => selectDisposition({ id: activeCall.id }, disposition.name)}
        >
          <span className="h-2.5 w-2.5 shrink-0 rounded-full" style={{ backgroundColor: disposition.color }} />
          {disposition.name}
          {dispositionShortcutKey(index) && (
            <kbd className="text-xs font-normal text-muted-foreground">{dispositionShortcutKey(index)}</kbd>
          )}
        </button>
      ))}
      {dispositions.length === 0 && (
        <span className="text-base text-muted-foreground">No dispositions configured for this organisation.</span>
      )}
      <Button className="ml-auto" onClick={onSaveAndNext} disabled={isSaving}>
        Save &amp; next
      </Button>
    </div>
  );
}
